"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountingBalanceLogFilter = exports.accountingBalanceLogFilterConfig = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dateTime_1 = require("../../../../utils/dateTime");
const Button_1 = require("../../../Button");
const Field_1 = require("../../../Form/Field");
const stable_1 = require("../../../Form/Field/DateRange/stable");
const BadgeMultiSelect_1 = require("../../../Form/Field/MultiSelect/BadgeMultiSelect");
const utils_1 = require("../../../Form/Field/MultiSelect/BadgeMultiSelect/utils");
const SearchAccount_1 = require("../../../Form/Field/SearchAccount");
const utils_2 = require("../../../Form/Field/SearchAccount/utils");
require("./index.scss");
const className = 'accounting-balance-log-filter';
const accountingBalanceLogFilterConfig = (data) => {
    var _a;
    return ({
        type: 'object',
        shape: {
            query: {
                type: 'string',
                optional: true,
                modificators: 'search',
            },
            account: {
                type: 'object',
                optional: true,
            },
            relatedAccount: {
                type: 'object',
                optional: true,
            },
            date: {
                type: 'object',
                optional: true,
                dateRestrictions: {
                    pastYearsCount: dateTime_1.bookingFilterPastYearsCount,
                    nextYearsCount: 0,
                },
                modificators: 'together',
                shape: {
                    from: {
                        type: 'date',
                        optional: true,
                    },
                    to: {
                        type: 'date',
                        optional: true,
                        dateRestrictions: {
                            notAllowedBeforeDate: (_a = data === null || data === void 0 ? void 0 : data.date) === null || _a === void 0 ? void 0 : _a.from,
                        },
                    },
                },
            },
            categories: {
                type: 'array',
                optional: true,
            },
        },
    });
};
exports.accountingBalanceLogFilterConfig = accountingBalanceLogFilterConfig;
const AccountingBalanceLogFilter = (props) => {
    const { field, onClickReset, submit, infoSlot, } = props;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const account = field(['account']);
    const relatedAccount = field(['relatedAccount']);
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: `${className}__form` },
            react_1.default.createElement(Field_1.FormFieldStable, { ...field(['query']), placeholder: formatMessage({
                    id: 'components/Accounting/BalanceLog:searchPlaceholder',
                    defaultMessage: 'Search',
                }), additionClassNames: `${className}__search`, prefixIcon: 'search' }),
            react_1.default.createElement(Button_1.Button, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Accounting/BalanceLog:SearchButton', defaultMessage: 'Search' }), modificators: ['ascetic', 'block'], onClick: submit, additionClassNames: `${className}__button` })),
        (account.hidden && relatedAccount.hidden) ? undefined : (react_1.default.createElement("div", { className: `${className}__form` },
            react_1.default.createElement(SearchAccount_1.SearchAccount, { ...account, toItem: utils_2.mapAccountListItemToSearchAccountItemType, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Accounting/BalanceLog:Account', defaultMessage: 'Account' }), additionClassNames: `${className}__account` }),
            react_1.default.createElement(SearchAccount_1.SearchAccount, { ...relatedAccount, toItem: utils_2.mapAccountListItemToSearchAccountItemType, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Accounting/BalanceLog:RelatedAccount', defaultMessage: 'Related Account' }), additionClassNames: `${className}__related-account` }))),
        react_1.default.createElement("div", { className: `${className}__form` },
            react_1.default.createElement(stable_1.FormFieldDateRangeStable, { ...field(['date']), additionClassNames: `${className}__dates`, fromField: {
                    ...field(['date', 'from']),
                    label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Accounting/BalanceLog:ReservedFrom', defaultMessage: 'From' })),
                }, toField: {
                    ...field(['date', 'to']),
                    label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Accounting/BalanceLog:ReservedTo', defaultMessage: 'To' })),
                } }),
            react_1.default.createElement(BadgeMultiSelect_1.BadgeMultiSelect, { ...field(['categories']), toItem: utils_1.mapBalanceLogRecordTypeToBadgeMultiSelectItem, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Accounting/BalanceLog:Categories', defaultMessage: 'Categories' }), additionClassNames: `${className}__categories` }),
            react_1.default.createElement(Button_1.Button, { icon: 'cycle', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Accounting/BalanceLog:ResetButton', defaultMessage: 'Reset' }), modificators: 'simple', onClick: onClickReset, additionClassNames: `${className}__reset` })),
        react_1.default.createElement("div", { className: `${className}__info` }, infoSlot)));
};
exports.AccountingBalanceLogFilter = AccountingBalanceLogFilter;
//# sourceMappingURL=index.js.map